import { useNosIdQuery } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { queryOptions } from '@tanstack/react-query';

export const loginOptionsQueryOptions = queryOptions({
  queryKey: ['login-options'],
  queryFn: () => api.get('/api/v1/personal-info/login-options'),
});

export function useGetLoginOptions() {
  return useNosIdQuery(loginOptionsQueryOptions);
}
